// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsModelsEnumsCommunicationType } from './clsModelsEnumsCommunicationType.js';
import type { ClsModelsEnumsGender } from './clsModelsEnumsGender.js';
import type { ClsModelsEnumsLanguage } from './clsModelsEnumsLanguage.js';
import type { ClsModelsEnumsSuffix } from './clsModelsEnumsSuffix.js';
import type { IAddress } from './iAddress.js';
import type { ICaregiverContact } from './iCaregiverContact.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IPatient {
    'firstName': string;
    'lastName': string;
    'middleName'?: string;
    'dateOfBirth': string;
    'cellPhone'?: string;
    'emailAddress'?: string;
    'emailOutput'?: boolean;
    'gender'?: ClsModelsEnumsGender;
    'homePhone'?: string;
    'mailOptOut'?: boolean;
    'phoneOptOut'?: boolean;
    'preferredCommunicationType'?: ClsModelsEnumsCommunicationType;
    'preferredLanguage'?: ClsModelsEnumsLanguage;
    'race'?: string;
    'residentOfUS'?: boolean;
    'suffix'?: ClsModelsEnumsSuffix;
    'textOptOut'?: boolean;
    'videoOptOut'?: boolean;
    'voicemailOptOut'?: boolean;
    'workPhone'?: string;
    'address': IAddress | null;
    'caregiverContact'?: ICaregiverContact | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IPatient>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "string"
        },
        {
            "name":     "cellPhone",
            "baseName": "cellPhone",
            "type":     "string"
        },
        {
            "name":     "emailAddress",
            "baseName": "emailAddress",
            "type":     "string"
        },
        {
            "name":     "emailOutput",
            "baseName": "emailOutput",
            "type":     "boolean"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "ClsModelsEnumsGender"
        },
        {
            "name":     "homePhone",
            "baseName": "homePhone",
            "type":     "string"
        },
        {
            "name":     "mailOptOut",
            "baseName": "mailOptOut",
            "type":     "boolean"
        },
        {
            "name":     "phoneOptOut",
            "baseName": "phoneOptOut",
            "type":     "boolean"
        },
        {
            "name":     "preferredCommunicationType",
            "baseName": "preferredCommunicationType",
            "type":     "ClsModelsEnumsCommunicationType"
        },
        {
            "name":     "preferredLanguage",
            "baseName": "preferredLanguage",
            "type":     "ClsModelsEnumsLanguage"
        },
        {
            "name":     "race",
            "baseName": "race",
            "type":     "string"
        },
        {
            "name":     "residentOfUS",
            "baseName": "residentOfUS",
            "type":     "boolean"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "ClsModelsEnumsSuffix"
        },
        {
            "name":     "textOptOut",
            "baseName": "textOptOut",
            "type":     "boolean"
        },
        {
            "name":     "videoOptOut",
            "baseName": "videoOptOut",
            "type":     "boolean"
        },
        {
            "name":     "voicemailOptOut",
            "baseName": "voicemailOptOut",
            "type":     "boolean"
        },
        {
            "name":     "workPhone",
            "baseName": "workPhone",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "IAddress"
        },
        {
            "name":     "caregiverContact",
            "baseName": "caregiverContact",
            "type":     "ICaregiverContact"
        },
    ];

    static getAttributeTypeMap() {
        return IPatient.attributeTypeMap;
    }
}
